import React, { PureComponent } from 'react';
import { SectionTypeInitialText, TypeSection } from '../../components/type-of-sections';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get, REDUCER_NAME } from '../../redux/modules/news-detail';
import { SocialButtons } from '../index';

class EventDetails extends PureComponent {

  componentWillMount() {
    const { match: { params: { eventId } } } = this.props;
    this.props.getAction(eventId);
  }

  render() {
    const { newsDetail: { values, isFetching } } = this.props;

    if (isFetching) {
      return <div/>;
    }

    if (Object.keys(values).length === 0) {
      return (<div className="row">
        <div className="main container event-detail">
          <div className="row">
            <div className="col-md-12 event-detail__section">
              <h4>A página pelo qual procura não esta disponivel</h4>
            </div>
          </div>
        </div>
      </div>);
    }

    return (
      <div className="row">
        <div className="main container event-detail">
          <div className="row">
            <div className="col-md-12 event-detail__section">
              <SectionTypeInitialText showDates={false} {...values}/>
            </div>
          </div>
          <div className="row">
            <TypeSection values={values}/>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      [REDUCER_NAME]: state[REDUCER_NAME]
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        getAction: get
      }, dispatch);
  }
)(EventDetails);




// WEBPACK FOOTER //
// ./src/containers/event-details/EventDetails.js